import {
  AnimationEvent,
  FormEvent,
  KeyboardEvent,
  MouseEvent,
  UIEvent,
  useLayoutEffect,
  WheelEvent,
} from 'react';

export default function useEvent(
  events: {
    target?: HTMLElement;
    handler: (
      event:
        | MouseEvent
        | KeyboardEvent
        | WheelEvent
        | UIEvent
        | Event
        | AnimationEvent
        | FormEvent
    ) => void;
    event: keyof DocumentEventMap;
  }[]
) {
  useLayoutEffect(() => {
    events.forEach(({ event, handler, target }) => {
      (target ?? document.body).addEventListener(event, handler);
    });
    return () => {
      events.forEach(({ event, handler, target }) => {
        (target ?? document.body).removeEventListener(event, handler);
      });
    };
  }, [events]);
}
